import gql from 'graphql-tag';

const GET_ALL = gql `
    query all($perPage: Int!,$page: Int, $where: WhistleblowerWhereWhereConditions){
        whistleblower(first: $perPage, page: $page, where: $where){
            data {
                id
                uuid,
                judul,
                deskripsi,
                nama_pelapor,
                email_pelapor,
                telepon_pelapor,
                status,
                kategori_whistleblower{
                  id,
                  nama
                }
            }
            paginatorInfo {
                count
                total
                hasMorePages
                currentPage
                lastPage
            }
        }
    }
`;

const GET_ALL_FILTER = gql `
  query Whistleblower($perPage: Int!, $page: Int, $filter: WhistleblowerFilterArgs, $orderBy: [WhistleblowerFilterOrderByOrderByClause!], $where: WhistleblowerFilterWhereWhereConditions) {
    whistleblower: whistleblowerFilter(first: $perPage, page: $page, filter: $filter, where: $where, orderBy: $orderBy) {
        data{
            id
            uuid,
            judul,
            deskripsi,
            nama_pelapor,
            email_pelapor,
            telepon_pelapor,
            status,
            kategori_whistleblower{
                id,
                nama
            }
        }
        paginatorInfo {
            count
            total
            hasMorePages
            currentPage
            lastPage
        }
    }
  }
`;

const GET_DETAIL = gql `
    query find($id: String!){
        whistleblowerByUuid(uuid: $id){
            id
            uuid,
            judul,
            deskripsi,
            nama_pelapor,
            email_pelapor,
            telepon_pelapor,
            status,
            kategori_whistleblower{
                id,
                nama
            }
            dokumen {
                id
                uuid
                nama
                lokasi
                besar_dokumen
                jenis_dokumen
                file_url
                tipe
                attribute
            }
        }
    }
`;

const UPDATE = gql `
    mutation($id: ID!, $input:WhistleblowerUpdateInput!){
        whistleblowerUpdate(id: $id,input:$input){
            uuid
            id
            judul,
            deskripsi
        }
    }
`;

export {
  GET_ALL,
  GET_ALL_FILTER,
  GET_DETAIL,
  UPDATE
}
